import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const AvgSalesInterval: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Avg. Interval',
  minWidth: 80,
  accessorFn: (product) => {
    if (product.stats.avg_sales_interval <= 0) {
      return '-';
    }

    return `${product.stats.avg_sales_interval.toFixed(0)}d`;
  },
  sortingFn: (a, b) => a.stats.avg_sales_interval - b.stats.avg_sales_interval,
  cell: ({ item: product, value }) => {
    if (product.stats.sales_interval_stddev <= 0) {
      return value;
    }

    return (
      <span title={`±${product.stats.sales_interval_stddev.toFixed(1)}d std dev`}>{value}</span>
    );
  },
});
